<template>
  <span class="c-shortcut-icon flex items-center border-rounded-1 px-2">
    <CIcon v-if="icon" class="text-center" :icon="icon" :size="16" />
    <template v-else-if="text">{{ text }}</template>
  </span>
</template>

<script lang="ts" setup>
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'

interface Props {
  text?: string
  icon?: string
}

defineProps<Props>()
const themeVars = useThemeVars()
</script>

<style lang="scss" scoped>
.c-shortcut-icon {
  font-weight: 500;
  font-size: 14px;
  height: 20px;
  color: v-bind('themeVars.primary');
  background: v-bind('themeVars.primary5');
}
</style>
